<template>
<div class="driverapplication">
  <!-- <el-form ref="sizeForm" :rules="rules" :model="sizeForm"> -->
  <el-form ref="sizeForm" :rules="rules" :model="sizeForm">
    <div class="wrap">
      <div class="main">
        <main class="main__content">
          <div class="step__sections">
            <div class="section section--shipping-address ">
              <!-- <div class="addAddress">
                <div class="section__header__driverapplication">
                  <h2 class="section__title">Myumyu Driver Partner</h2>
                </div>
                <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                  <div class="title" :class="showDescription?'':'bg_none'" @click="showDescription = !showDescription">
                    <i :class="showDescription?'el-icon-minus':'el-icon-plus'"></i><span>Description</span>
                  </div>
                  <div class="fieldset_description" v-show="showDescription">
                    <div class='description'>
                      <p class="sub-header">Why Parter With Myumyu</p>
                      <p>1. Earn a per order commision + 100% of your tips</p>
                      <p>2. Make a guaranteed hourly minimum* (varies by market)</p>
                      <p>3. Choose your own schedule and deliver when you want</p>
                      <p>4. No restaurants, no riders - deliver from a gopuff facility, that's it!</p>
                      <p class="sub-header">What you'll need to get started</p>
                      <p>1. Gotta be 21 years old</p>
                      <p>2. Valid U.S. driver's license</p>
                      <p>3. Vehicle insurance & registration</p>
                      <p>4. Smartphone</p>
                      <p>5. Will & able to pass a pre-paid alcohol delivery training course (where applicable)</p>
                      <p class="sub-header">How it workds</p>
                      <p>1. Login to the goDrive app from your local facility</p>
                      <p>2. Grab a few orders</p>
                      <p>3. Deliver to happy customers</p>
                      <p class="sub-header">No previous delivery experience required! Apply today!</p>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="addAddress">
                <div class="section__header__driverapplication">
                  <h2 class="section__title">{{ $t('driverApplication') }}</h2>
                  <div v-if="errorSubmitting" class="time_tip"><span>{{ $t('correctErrors') }}</span></div>
                </div>
                <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                  <div class="title" :class="isAddAddress?'':'bg_none'" @click="isAddAddress = !isAddAddress">
                    <i :class="isAddAddress?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addNewAddress') }}</span>
                  </div>
                  <div class="fieldset" v-show="isAddAddress">
                    <div class="field">
                      <div class="two">
                        <div class="width">
                          <el-form-item v-bind:label="$t('firstName')" prop="first_name">
                            <el-input v-bind:placeholder="$t('firstName')" v-model="sizeForm.first_name"></el-input>
                          </el-form-item>
                        </div>
                        <div class="width">
                          <el-form-item v-bind:label="$t('lastName')" prop="last_name">
                            <el-input v-bind:placeholder="$t('lastName')" v-model="sizeForm.last_name"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="two">
                        <div class="width">
                          <el-form-item v-bind:label="$t('email')" prop="email">
                            <el-input v-bind:placeholder="$t('email')" v-model="sizeForm.email"></el-input>
                          </el-form-item>
                        </div>
                        <div class="width">
                          <el-form-item v-bind:label="$t('phone')" prop="phone_number">
                            <el-input v-bind:placeholder="$t('phone')" v-model="sizeForm.phone_number"></el-input>

                          </el-form-item>
                        </div>
                      </div>

                      <!-- <div class="two">
                        <div class="width">
                          <el-form-item label="Country" prop="country">
                            <el-input placeholder="Country/Region" v-model="sizeForm.country"></el-input>
                          </el-form-item>
                        </div>
                        <div class="width">
                          <el-form-item label="city" prop="city">
                            <el-input placeholder="City" v-model="sizeForm.city"></el-input>
                          </el-form-item>
                        </div>
                      </div> -->
                      <button class="place btn" @click="onSubmit(sizeForm, $event)">{{ $t('submit') }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

      </div>
    </div>
  </el-form>
</div>
</template>

<script>
import {
  mapState,
  mapMutations,
  mapActions,
} from "vuex";
import {
  Alert
} from "element-ui";
export default {
  name: "driverapplication",
  data() {
    return {
      //表单默认数据
      sizeForm: {
        first_name: '', //名字
        last_name: '', //名字
        phone_number: '',
        email: '',
        city: '', //城市
        country: 'United States', //国家/地区
      },
      //下拉框默认数据
      isAddAddress: true,
      showDescription: false,
      errorSubmitting: false,
    }
  },
  computed: {
    rules(){
      return {
        first_name: [{
            required: true,
            message: this.$t('firstNameRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 20,
            message: this.$t('firstNameLengthRequired'),
            trigger: 'blur'
          }
        ],
        last_name: [{
            required: true,
            message: this.$t('lastNameRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 20,
            message: this.$t('lastNameLengthRequired'),
            trigger: 'blur'
          }
        ],
        city: [{
            required: true,
            message: this.$t('cityRequired'),
            trigger: 'blur'
          },
          // { min: 3, max: 20, message: 'city length at least 3', trigger: 'blur' }
        ],
        phone_number: [{
            required: true,
            message: this.$t('phoneNumberRequired'),
            trigger: 'blur'
          },
          {
            min: 10,
            max: 12,
            message: this.$t('phoneNumberLengthRequired'),
            trigger: 'blur',
          }
        ],
        country: [{
            required: true,
            message: this.$t('countryRequired'),
            trigger: 'blur'
          },
          // { min: 3, max: 20, message: 'Country length at least 3', trigger: 'blur' }
        ],
        email: [{
            required: true,
            message: this.$t('emailRequired'),
            trigger: 'blur'
          },
          {
            message: this.$t('emailValidRequired'),
            trigger: 'blur',
            type: 'email'
          },
        ],
      }
    }
  },
  methods: {
    ...mapActions('driverApplication', ['apply']),
    onSubmit(sizeForm, event) {
      event.preventDefault();
      this.errorSubmitting = false;
      this.$refs['sizeForm'].validate((valid) => {
        if (!valid) {
          this.errorSubmitting = true;
          return;
        } else {
          this.apply(this.sizeForm)
            .then(res => {
              // async
              // Object.assign(this.$data, this.$options.data.apply(this));
              this.sizeForm = {
                  first_name: '', //名字
                  last_name: '', //名字
                  phone_number: '',
                  email: '',
                  city: '', //城市
                  country: 'United States', //国家/地区
                },
                this.$refs['sizeForm'].clearValidate();
              this.openAlert();
            })
            .catch(err => {
              alert(err);
            })
        }
      });
    },
    openAlert() {
      this.$alert('You have submitted an application', 'Success', {
        confirmButtonText: 'OK',
        // cancelButtonText: null,
        type: 'success',
        center: true
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
  },
}
</script>

<style lang="less">
@import "../assets/css/driverapplication.less";
</style>



// WEBPACK FOOTER //
// src/view/driverApplication.vue